<template>
  <RouterView />
</template>

<script>
import auth from '@/utils/auth'

import { mapGetters, mapActions } from 'vuex'

let autoUpdateIntervalId = null

export default {
  name: 'App',
  computed: {
    ...mapGetters('user', ['isAuth'])
  },
  methods: {
    ...mapActions({
      setLanguages: 'languages/setLanguages',
      setUser: 'user/setUser',
      logout: 'user/logout',
      refreshToken: 'user/refreshToken'
    })
  },
  watch: {
    isAuth: {
      immediate: true,
      handler () {
        if (this.isAuth) {
          const now = Date.now()
          const intervalLength = Math.max(auth.tokenExp - now, 30000)
          autoUpdateIntervalId = setInterval(() => {
            this.refreshToken()
          }, intervalLength)
        } else {
          clearInterval(autoUpdateIntervalId)
          if (!this.$route.meta.ignoreAuth) {
            this.$router.replace({ name: 'login' })
          }
        }
      }
    }
  },
  created () {
    this.setLanguages()
  },
  destroyed () {
    clearInterval(autoUpdateIntervalId)
  }
}
</script>

<style>
  .table-wrapper {
    position: relative;
    width: 100%;
  }

  tr:hover {
    cursor: pointer;
  }
</style>
